@if (!isInCarousel) { @if (contentlet().bannerTitle) {
<h1 class="mb-2 text-6xl font-bold text-shadow" [ngStyle]="{ color: contentlet()?.textColor }" [class]="animationCss()">
  <custom-dot-editable-text fieldName="bannerTitle" [mode]="'minimal'" [format]="'html'" [contentlet]="contentlet()" />
</h1>
} @if (contentlet().caption) {
<p [class]="animationCss()" [ngStyle]="{ color: contentlet()?.textColor }">
  <custom-dot-editable-text fieldName="caption" [mode]="'minimal'" [format]="'html'" [contentlet]="contentlet()" />
</p>
} @if (contentlet()?.buttonText && contentlet()?.link) {
<a
  [class]="animationCss()"
  class="btn btn-primary button-leaf"
  [style.backgroundColor]="contentlet()?.buttonColor"
  [ngStyle]="{ color: contentlet()?.textColor }"
  (click)="selectPromotionGTMEvent()"
>
  <div class="hover-border-top" [style.backgroundColor]="contentlet()?.buttonColor"></div>
  <div class="link-text">{{ this.contentlet().buttonText }}</div>
  <div class="hover-border-bottom" [style.backgroundColor]="contentlet()?.buttonColor"></div>
</a>
} } @else { @if (contentlet().bannerTitle) {
<h1
  [class]="animationCss()"
  [ngStyle]="{ color: contentlet()?.textColor }"
  [ishServerHtml]="contentlet().bannerTitle"
></h1>
} @if (contentlet().caption) {
<p [class]="animationCss()">
  <span [ngStyle]="{ color: contentlet()?.textColor }" [ishServerHtml]="contentlet().caption"> </span>
</p>
} @if (contentlet()?.buttonText && contentlet()?.link) {
<a
  [class]="animationCss()"
  class="btn btn-primary button-leaf"
  [style.backgroundColor]="contentlet()?.buttonColor"
  [ngStyle]="{ color: contentlet()?.textColor }"
  (click)="selectPromotionGTMEvent()"
>
  <div class="hover-border-top" [style.backgroundColor]="contentlet()?.buttonColor"></div>
  <div class="link-text">{{ this.contentlet().buttonText }}</div>
  <div class="hover-border-bottom" [style.backgroundColor]="contentlet()?.buttonColor"></div>
</a>
} }
